var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPptx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.84001C8.5 1.99514 9.99514 0.5 11.84 0.5H39.8179L55.5001 13.673V60.16C55.5001 62.0049 54.0049 63.5 52.1601 63.5H11.84C9.99514 63.5 8.5 62.0049 8.5 60.16V3.84001Z",
    stroke: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V9.59996C40 11.721 41.719 13.44 43.84 13.44H56.0001",
    fill: "#FB8C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4238 41.0864H14.4319V45.0006H12V33.7598H16.4238C17.3142 33.7598 18.0759 33.9219 18.709 34.2461C19.3472 34.5704 19.8362 35.0156 20.1759 35.5818C20.5207 36.1428 20.6931 36.7836 20.6931 37.5041C20.6931 38.5953 20.3148 39.4651 19.5582 40.1136C18.8016 40.7621 17.7568 41.0864 16.4238 41.0864ZM16.4238 35.7207H14.4319V39.1331H16.4238C17.062 39.1331 17.5226 38.9839 17.8057 38.6854C18.0888 38.3817 18.2303 37.9931 18.2303 37.5196C18.2303 37.0512 18.0888 36.6343 17.8057 36.2689C17.5226 35.9035 17.062 35.7207 16.4238 35.7207Z",
    fill: "#FB8C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.661 41.0864H24.6691V45.0006H22.2372V33.7598H26.661C27.5514 33.7598 28.3131 33.9219 28.9462 34.2461C29.5844 34.5704 30.0734 35.0156 30.4131 35.5818C30.7579 36.1428 30.9303 36.7836 30.9303 37.5041C30.9303 38.5953 30.552 39.4651 29.7954 40.1136C29.0388 40.7621 27.994 41.0864 26.661 41.0864ZM26.661 35.7207H24.6691V39.1331H26.661C27.2992 39.1331 27.7598 38.9839 28.0429 38.6854C28.326 38.3817 28.4675 37.9931 28.4675 37.5196C28.4675 37.0512 28.326 36.6343 28.0429 36.2689C27.7598 35.9035 27.2992 35.7207 26.661 35.7207Z",
    fill: "#FB8C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6084 45.0006H35.1842V35.7207H31.8182V33.7598H41.0208V35.7207H37.6084V45.0006Z",
    fill: "#FB8C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1135 37.5412L49.1362 33.7351H51.9232L48.6884 39.3092L52.0004 44.9759H49.1902L47.1135 41.1003L45.029 44.9759H42.2188L45.5385 39.3092L42.296 33.7351H45.083L47.1135 37.5412Z",
    fill: "#FB8C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.576ea2d1.svg";
export { ForwardRef as ReactComponent };